import { Dialog, DialogTitle, DialogContent, DialogActions, Button } from '@mui/material';
import "./ConfirmationModal.css";

const ConfirmationModal = ({ open, onClose, onConfirm, title, message }) => {
  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle className='modal-confirm-title'>{title}</DialogTitle>
      <DialogContent>
        <p>{message}</p>
      </DialogContent>
      <DialogActions className='modal-confirm-btns'> 
        <Button onClick={onConfirm} className='modal-primary-btn' variant="contained">
          Confirmer
        </Button>
        <Button onClick={onClose} className='modal-cancel-btn'>
          Annuler
        </Button>
       
      </DialogActions>
    </Dialog>
  );
};

export default ConfirmationModal;